import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar, { scrollToHash } from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import LegalPage from "./pages/LegalPage";
import ContactPage from "./pages/ContactPage";

const BASE_URL = "https://look-aura.app";
const HASH_SCROLL_DELAY_MS = 300;

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => scrollToHash(hash), HASH_SCROLL_DELAY_MS);
            return () => clearTimeout(t);
        }
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

const CanonicalUpdater = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        const url = pathname === "/" ? `${BASE_URL}/` : `${BASE_URL}${pathname}`;
        document.querySelector('link[rel="canonical"]')?.setAttribute("href", url);
        document.querySelector('meta[property="og:url"]')?.setAttribute("content", url);
        document.querySelector('meta[name="twitter:url"]')?.setAttribute("content", url);
    }, [pathname]);
    return null;
};

const LenisProvider = ({ children }) => {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, anchors: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);
    return children;
};

function App() {
    return (
        <BrowserRouter>
            <LenisProvider>
                <ScrollToTop />
                <CanonicalUpdater />
                <div className="noise-overlay" aria-hidden="true" />
                <Navbar />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
                    <Route path="/terms" element={<LegalPage pageKey="terms" />} />
                    <Route path="/affiliate-disclosure" element={<LegalPage pageKey="affiliate-disclosure" />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
                <Footer />
            </LenisProvider>
        </BrowserRouter>
    );
}

export default App;
